import { cloneDeep } from 'lodash';
import { Six_To_12_Options } from './../../../../shared/constants/mad-libs/dimension1-options/6-to-12-options.constant';
import { Six_to_8_Options } from './../../../../shared/constants/mad-libs/dimension1-options/6-to-8-options.constant';
import { Nine_To_12_Options } from './../../../../shared/constants/mad-libs/dimension1-options/9-to-12-options.constant';
import { K_to_5_Options } from './../../../../shared/constants/mad-libs/dimension1-options/k-to-5-options.constant';
import { K_To_8_Options } from './../../../../shared/constants/mad-libs/dimension1-options/k-to-8-options.constant';

import {
  courseOptions,
  esAndMsSubjectOptions,
  flagOptions,
  fpOptions,
  fpOptionsInstructScore,
  fpOptionsRelScore,
  fpOptionsSupport,
  hsSubjectOptions,
  iReadyOptions,
  progressOptions,
  RiskGroupOptions,
  stateExamOptions,
  subjectFailureOptions,
  supportOptions,
} from './academic-mad-lib-options.constant';

// DIMENSIONS

export const DIMENSION_1 = {
  madLib: 'Dimension1',
  options: {
    'K to 5': K_to_5_Options,
    'K to 8': K_To_8_Options,
    '6 to 8': Six_to_8_Options,
    '6 to 12': Six_To_12_Options,
    'Large HS': Nine_To_12_Options,
    'Small HS': Nine_To_12_Options,
    Charter: Nine_To_12_Options,
    Transfer: Nine_To_12_Options,
  },
  helperText: 'focused on',
};

export const DIMENSION_2 = {
  madLib: 'Dimension2',
  options: {
    ES: [...iReadyOptions, ...stateExamOptions, ...fpOptions],
    MS: [...courseOptions, ...esAndMsSubjectOptions, ...iReadyOptions, ...stateExamOptions, ...fpOptions],
    HS: [...courseOptions, ...hsSubjectOptions],
  },
  helperText: 'grouped by',
};

export const GROUPING = {
  madLib: 'Groupings',
  options: {
    // TODO: need to update these to align with possible options
    ELA_IREADY: [...RiskGroupOptions.getEla(), ...supportOptions, ...flagOptions],
    MATH_IREADY: [...RiskGroupOptions.getMath(), ...supportOptions, ...flagOptions],
    STATE_EXAM: [...RiskGroupOptions.getEla(), ...RiskGroupOptions.getMath(), ...supportOptions, ...flagOptions],
    'F_&_P_ELA': [...fpOptionsRelScore, ...fpOptionsInstructScore, ...fpOptionsSupport],
    COURSE_GRADES: [...progressOptions, ...supportOptions],
    HIGH_PRIORITY_COURSE_GRADES: [...progressOptions, ...supportOptions],
    // ES & MS
    ELA_CORE_MS: [...subjectFailureOptions],
    MATH_CORE_MS: [...subjectFailureOptions],
    SCI_CORE_MS: [...subjectFailureOptions],
    SS_CORE_MS: [...subjectFailureOptions],
    // HS
    ELA_CORE: [...subjectFailureOptions],
    MATH_ALG: [...subjectFailureOptions],
    MATH_GEOM: [...subjectFailureOptions],
    MATH_TRIG: [...subjectFailureOptions],
    SS_GLOBAL: [...subjectFailureOptions],
    SS_US: [...subjectFailureOptions],
    SS_ECON: [...subjectFailureOptions],
    SS_GOVT_ECON: [...subjectFailureOptions],
    SS_GOVT: [...subjectFailureOptions],
    SCI_LIVING: [...subjectFailureOptions],
    SCI_BIO: [...subjectFailureOptions],
    SCI_CHEM: [...subjectFailureOptions],
    SCI_EARTH: [...subjectFailureOptions],
    SCI_PHYSICS: [...subjectFailureOptions],
    LOTE: [...subjectFailureOptions],
    PE: [...subjectFailureOptions],
    HEALTH: [...subjectFailureOptions],
    ART: [...subjectFailureOptions],
    CTE: [...subjectFailureOptions],
  },
};

// Used for testing purposes only -- remove when writing tests
export const ACADEMIC_MAD_LIB = [DIMENSION_1, DIMENSION_2, GROUPING];

// Keep access to originalDimensions
export const ORIGINAL_DIMENSION_2 = cloneDeep(DIMENSION_2);

// Needed to generate madlib State within resolve blocks
export const ACADEMIC_MADLIB_CONFIG = {
  DIMENSION_1,
  DIMENSION_2,
  GROUPING,
  listType: 'ACADEMIC',
  dimensionsAreIndependent: false,
  hasDimensionParams: $stateParams => {
    const { Dimension1, Dimension2, Groupings } = $stateParams;
    const hasDimensionParams = !!(Dimension1 && Dimension2 && Groupings);
    return hasDimensionParams;
  },
};
